import { HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { MarknadsomradeDTO } from "~app/common/models/common/MarknadsomradeDTO";
import { ITypeAheadResult } from "~app/common/models/type-ahead-result.model";
import { ApiClientService } from "~app/common/services/api-client.service";
import { IKundDetail } from "../models/kundDetail";
import { KontaktKundListResponseDTO } from "../models/kundList";
import { KundSearchParamsModel } from "../models/kundSearchParamsModel";

@Injectable({
    providedIn: "root"
})
export class KundService {
    private readonly apiClient = inject(ApiClientService);

    private readonly legacyRoute: boolean = true;

    searchForKundTypeAhead(input: string): Observable<ITypeAheadResult[]> {
        const subject = new Subject<ITypeAheadResult[]>();
        if (input.length < 3) {
            return subject.asObservable();
        }
        return this.apiClient.post<any, ITypeAheadResult[]>(`Kund/SearchForKundTypeAhead`, `"${input}"`, this.legacyRoute, null, this.getHeader());
    }

    searchForKund(kundSearchParams: KundSearchParamsModel): Observable<KontaktKundListResponseDTO> {
        return this.apiClient.post<any, KontaktKundListResponseDTO>(`Kund/SearchForKontaktKund`, kundSearchParams, this.legacyRoute, null, this.getHeader());
    }

    getKundById(id: number): Observable<IKundDetail> {
        return this.apiClient.get<IKundDetail>(`Kund/GetKontaktKundById/${id}`, this.legacyRoute, this.getHeader());
    }

    saveKund(kund: IKundDetail): Observable<IKundDetail> {
        return this.apiClient.post(`Kund/SaveKontaktKund`, kund, this.legacyRoute, null , this.getHeader());
    }

    getMarknadsomraden(): Observable<MarknadsomradeDTO[]> {
        return this.apiClient.get<MarknadsomradeDTO[]>("/verksamhetsomrade/marknadsomrade", false);
    }

    getBefraktareColors(): Observable<string[]> {
        return this.apiClient.getCached<string[]>("kund/colors", false);
    }

    private getHeader(): HttpHeaders {
        const headers = new HttpHeaders();
        return headers.append("content-type", "application/json");
    }
}
